import moment from 'moment-timezone';

export default {
    data() {
        return {
            timezones: moment.tz.names().map(t => ({text: t.replace(/_/g, ' '), value: t })),

        }
    },
    methods: {
        guessTZ() {
            return moment.tz.guess();
        },
        getUTCDate(tzdate, zone) {
            return new Date(moment.tz(tzdate, zone).utc().format());
        },
        formatDateTZ(d, dateOnly, noValueText = this.$t('common.never'), zone) {
            if(!d) {
                return noValueText;
            }
            if(typeof(d) === 'string' || typeof(d) === 'number') {
                d = new Date(d);
            }
            if(d.valueOf() == 0) {
                return noValueText;
            }
            let format = dateOnly ? 'LL' : 'LLL';
            return moment(d).tz(zone).format(format); 
        }
    },
    created() {
        moment.locale(this.$store.state.ui.locale);
    }
}